import client from './client'
import type { CrowdWorker, CrowdWorkerStats } from '../types'

export async function getMyProfile(): Promise<CrowdWorker> {
  const res = await client.get('/v1/crowd/workers/me')
  return res.data
}

export async function getMyStats(): Promise<CrowdWorkerStats> {
  const res = await client.get('/v1/crowd/workers/me/stats')
  return res.data
}

export interface Language {
  code: string
  name: string
  native_name: string
  is_default: boolean
}

export async function getLanguages(): Promise<Language[]> {
  const res = await client.get('/v1/crowd/workers/languages')
  return res.data
}

export async function updatePreferences(data: { preferred_language?: string }): Promise<CrowdWorker> {
  const res = await client.patch('/v1/crowd/workers/me/preferences', data)
  return res.data
}
